import {lazy} from 'react'
import {Route, Routes} from 'react-router-dom'

export enum ProviderRouterEnum {
    DatatableDoctors = '/prestadores/profissionais',
    RegisterDoctor = '/prestadores/profissionais/cadastro',
    ProfileDoctors = '/prestadores/profissionais/:id',
}

/*Profissionais*/
const DatatableDoctors = lazy(() => import('../../pages/providers/doctors/DatatableDoctors'))
const RegisterDoctor = lazy(() => import('../../pages/providers/doctors/RegisterDoctor'))
const ProfileDoctors = lazy(() => import('../../pages/providers/doctors/ProfileDoctor'))

export function ProviderRouter() {
    return (
        <Routes>
            {/* Profissionais - paths relativos ao prefixo /prestadores consumido em PrivateRoutes */}
            <Route path='profissionais/cadastro' element={<RegisterDoctor />} />
            <Route path='profissionais/:id' element={<ProfileDoctors />} />
            <Route path='profissionais' element={<DatatableDoctors />} />
        </Routes>
    )
}
